import React, { useState } from "react";
import { clsx } from "clsx";
import { UnitItemContext } from "@/context/unitItemContext";
import { UnitPromotions } from "@/components/units/unit/info/unitPromotions";
import { UnitFeatures } from "@/components/units/unit/info/unitFeatures";
import { UnitUrgency } from "@/components/units/unit/info/unitUrgency";
import { UnitPrice } from "@/components/units/unit/info/unitPrice";
import { UnitImage } from "@/components/units/unit/info/unitImage";
import { NearbyCollapseV2 } from "@/components/units/unit/info/nearbyCollapseV2";
import type { UnitGroup } from "@/types";
import { Button } from "@/components/ui/button";
import { CollapsibleTrigger } from "@/components/ui/collapsible";
import { UnitAction } from "./info/unitAction";

interface UnitItemProps {
    unitGroup: UnitGroup;
    layout: "grid" | "row";
}

export const UnavailableUnitItem = ({
    unitGroup,
    layout = "row",
}: UnitItemProps) => {
    const { representative_unit, rates, available, show_nearby_units } = unitGroup;
    const [selectedPromo, setSelectedPromo] = useState<number>(() => {
        if (rates.promo_rates.length === 1 || rates.promo_rates.length > 1) {
            return rates.promo_rates[0].id;
        } else {
            return 0;
        }
    });

    const unitItemInfo = {
        unitGroup,
        selectedPromo,
        setSelectedPromo,
    };

    const [isOpen, setIsOpen] = useState(false);
    const toggleNearby = () => setIsOpen((prev) => !prev);

    return (
        <UnitItemContext.Provider value={unitItemInfo}>
            <NearbyCollapseV2
                isOpen={isOpen}
                onToggle={toggleNearby}
                className={clsx("unit-item", "unit-item--" + layout)}
            >
                <div className="unit-item__image">
                    <UnitImage
                        length={representative_unit.length}
                        width={representative_unit.width}
                    />
                </div>
                <div className="unit-item__dimension">
                    {`${representative_unit.width}' x ${representative_unit.length}'`}
                </div>
                <div className="unit-item__category">
                    {representative_unit.category?.name ?? ""}
                </div>
                <div className="unit-item__features">
                    <UnitFeatures features={representative_unit.features} />
                </div>
                <div className="unit-item__promotions">
                    <UnitPromotions promotions={rates.promo_rates} />
                </div>
                <div className="unit-item__urgency">
                    <UnitUrgency available={available} />
                </div>
                <div className="unit-item__price">
                    <UnitPrice rates={rates} />
                </div>
                <div className="unit-item__action">
                    <UnitAction />
                    {
                        show_nearby_units && (
                            <CollapsibleTrigger asChild>
                                <Button variant={"default"} className="find-nearby-btn">Find Nearby</Button>
                            </CollapsibleTrigger>
                        )
                    }
                </div>
            </NearbyCollapseV2>
        </UnitItemContext.Provider>
    );
};
